import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 05F25B05-A6D6-4863-8B21-6969E10329CF
 * name arrow-right
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-right.svg
 * tags
 * - Arrow 
 */
export const ArrowRightIcon = createSvgIcon(<><path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" /></>, 'ArrowRightIcon');
export default ArrowRightIcon